<template>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card bg-pattern">
            <div class="card-body p-4">
              <div class="text-center w-75 m-auto">
                <a class="app-name" href="https://www.freelanceinsights.com">
                  <span>Freelance</span>
                  <span>Insights</span>
                </a>
                <p v-if="step === 0" class="text-muted mb-4 mt-3">
                  Enter your email address and a password to create an account!
                </p>
              </div>

              <Signup v-if="step === 0" @signedup="onSignedUp" />
              <ProviderConnect v-if="step === 1" @connected="onProviderConnected" @skipconnect="onSkipConnect" />
              <AccountReady v-if="step === 2" @getstarted="onGetStarted" />
            </div> <!-- end card-body -->
          </div>
          <!-- end card -->

          <div v-if="step === 0" class="row mt-3">
            <div class="col-12 text-center">
              <p class="text-white-50">
                Already have an account? <router-link :to="{ name: 'login' }" class="text-white ml-1">
                  <b>Log In</b>
                </router-link>
              </p>
            </div> <!-- end col -->
          </div>
          <!-- end row -->
        </div> <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end page -->
</template>

<script>
import {
  mapState,
} from 'vuex';

import Signup from '@/views/onboarding/Signup';
import ProviderConnect from '@/views/onboarding/ProviderConnect';
import AccountReady from '@/views/onboarding/AccountReady';


export default {
  name: 'Onboarding',
  components: {
    Signup,
    ProviderConnect,
    AccountReady,
  },

  data() {
    return {
      step: 0,
    };
  },

  computed: {
    ...mapState({
    }),
  },

  methods: {
    onSubmit() {
      this.onLoginUser(this.email, this.password);
    },

    async onSignedUp() {
      this.step += 1;
    },

    async onProviderConnected() {
      this.step += 1;
    },

    async onGetStarted() {
      this.$router.push({
        name: 'Home',
      });
    },

    async onSkipConnect() {
      this.$router.push({
        name: 'Home',
      });
    },
  },
};
</script>

<style lang="scss" scoped>

h3 {
  font-size: 1.1rem;
}

</style>
